import { render, staticRenderFns } from "./PodAffinity.vue?vue&type=template&id=185f4eb4&"
import script from "./PodAffinity.vue?vue&type=script&lang=js&"
export * from "./PodAffinity.vue?vue&type=script&lang=js&"
import style0 from "./PodAffinity.vue?vue&type=style&index=0&id=185f4eb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports